import { render, staticRenderFns } from "./absoluteContradictions.vue?vue&type=template&id=3b4606b6&scoped=true"
import script from "./absoluteContradictions.vue?vue&type=script&lang=js"
export * from "./absoluteContradictions.vue?vue&type=script&lang=js"
import style0 from "./absoluteContradictions.vue?vue&type=style&index=0&id=3b4606b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4606b6",
  null
  
)

export default component.exports